import React, { useState, useEffect, useRef } from 'react';
import './css/Navbar.css';
import logo from './images/logo1.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faUser, faTicket, faEnvelope, faDoorOpen } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import train from './images/train.png'
import token_icon from './images/token_nqtb.png'
import authService from '../auth/authService';
import labService from './labService'

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const menuRef = useRef(null);
    const menuButtonRef = useRef(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserData = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                setLoading(false);
                return;
            }

            const parsedUserData = JSON.parse(userData);
            const token = parsedUserData.access;
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const response = await labService.getUserInfo(token);
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user data', error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(prevState => !prevState);
    };

    const handleMenuItemClick = (path) => {
        navigate(path);
        setIsMenuOpen(false);
    };

    const handleClickOutside = (event) => {
        if (
            menuRef.current && 
            !menuRef.current.contains(event.target) &&
            menuButtonRef.current && 
            !menuButtonRef.current.contains(event.target)
        ) {
            setIsMenuOpen(false);
        }
    };

    const handleLogout = () => {
        authService.logout();
        window.location.reload(); // Refresh the page to clear state
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <nav className="navbar">
            <div className="left">
                <img className="logo-nav" src={logo} alt="logo" />
                
            </div>
            <div className="spacer"></div>
            <div className="right">
                
                <button className='training-button' onClick={() => handleMenuItemClick('/contact')}>
                     <FontAwesomeIcon icon={faEnvelope} className="train" />
                    Contact us
                </button>
                <button onClick={() => handleMenuItemClick('/wallet')} className='token-nav'>
                    <img className="token-icon" src={token_icon} alt="token icon" />
                    {user ? `${user.coins} tokens`  : 'Loading'}
                </button>
                <div className='user-menu'>
                    <FontAwesomeIcon 
                        icon={faBars} 
                        className="hamburger-icon" 
                        onClick={toggleMenu} 
                        ref={menuButtonRef} 
                    />
                    {isMenuOpen && (
                        <div className="dropdown-menu" ref={menuRef}>
                            <div className="menu-item" onClick={() => handleMenuItemClick('/user-form')}>
                                <FontAwesomeIcon icon={faUser} className="menu-icon" />
                                <div>
                                    <strong className='nav-surname'>{user.name} {user.surname}</strong>
                                    <div>{user.email}</div>
                                </div>
                            </div>
                            <div className="menu-item" onClick={() => handleMenuItemClick('/redeem-coupon')}>
                                <FontAwesomeIcon icon={faTicket} className="menu-icon" />
                                <div>
                                    <strong>Redeem code</strong>
                                    <div>Enter a promotional code</div>
                                </div>
                            </div>
                            
                            <div className="menu-item" onClick={() => handleLogout()}>
                                <FontAwesomeIcon icon={faDoorOpen} className="menu-icon" />
                                <div>
                                    <strong>Logout</strong>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
